<template>
  <div v-loading="fullscreenLoading">
    <div style="margin-left: 10.5%; overflow: hidden">
      <div style="padding-top: 20px"></div>
      <!-- <div>
        <button @click="generate">导出</button>
      </div>-->
      <div
        class="Rectangle-5"
        v-bind:style="{ height: +(windowHeight - 150) + 'px' }"
      >
        <div style="padding: 1.5%">
          <div style>
            <div style="display: inline-block; width: 75%">
              <div>
                <el-select
                  style="
                    display: inline-block;
                    width: 150px;
                    vertical-align: middle;
                  "
                  placeholder="请选择地区"
                  v-model="searchArea"
                  @keyup.enter.native="onSearchTableData"
                >
                  <el-option
                    v-for="item in areaList"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>

                <el-input
                  style="
                    display: inline-block;
                    max-width: 250px;
                    vertical-align: middle;
                    margin-left: 10px;
                  "
                  v-model="searchKeyword"
                  placeholder="订单号、电话、客户备注、价格"
                  @keyup.enter.native="onSearchTableData"
                ></el-input>

                <el-date-picker
                  v-model="searchDate"
                  value-format="yyyy-MM-dd"
                  style="
                    display: inline-block;
                    vertical-align: middle;
                    margin-left: 10px;
                  "
                  type="daterange"
                  range-separator="至"
                  start-placeholder="下单开始日期"
                  end-placeholder="下单结束日期"
                  @keyup.enter.native="onSearchTableData"
                ></el-date-picker>
              </div>

              <div style="display: inline-block; width: 100%; margin-top: 10px">
                <el-date-picker
                  v-model="searchDeliveryDate"
                  value-format="yyyy-MM-dd"
                  style="display: inline-block; vertical-align: middle"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="送货开始日期"
                  end-placeholder="送货结束日期"
                  @keyup.enter.native="onSearchTableData"
                ></el-date-picker>
                <el-select
                  multiple
                  style="
                    display: inline-block;
                    width: 200px;
                    vertical-align: middle;
                    margin-left: 10px;
                  "
                  placeholder="请选择订单状态"
                  v-model="searchStatus"
                  @keyup.enter.native="onSearchTableData"
                >
                  <el-option
                    v-for="item in statusList"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>

                <el-select
                  style="
                    display: inline-block;
                    width: 150px;
                    vertical-align: middle;
                    margin-left: 10px;
                  "
                  placeholder="请选择支付方式"
                  v-model="searchPaymentWay"
                  @keyup.enter.native="onSearchTableData"
                >
                  <el-option
                    v-for="item in paymentWaySearchList"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  ></el-option>
                </el-select>

                <el-select
                  style="
                    display: inline-block;
                    width: 120px;
                    vertical-align: middle;
                    margin-left: 10px;
                  "
                  placeholder="请选择货车"
                  v-model="searchCar"
                  @keyup.enter.native="onSearchTableData"
                >
                  <el-option
                    v-for="item in carSearchList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>

                <el-button
                  @click="onSearchTableData"
                  style="
                    display: inline-block;
                    margin-left: 10px;
                    background-color: #1bb24b;
                    vertical-align: middle;
                  "
                  type="success"
                  >搜索</el-button
                >
              </div>
            </div>

            <div
              style="
                display: inline-block;
                text-align: right;
                width: 25%;
                vertical-align: top;
              "
            >
              <div>
                <el-button
                  @click="onDialogBoolMsgPhoneOpen()"
                  style="color: #1bb24b; border-color: #1bb24b"
                  >导电话</el-button
                >

                <el-button
                  @click="onDialogBoolAddressOpen()"
                  style="color: #1bb24b; border-color: #1bb24b"
                  >导地址</el-button
                >

                <el-button
                  @click="onDialogBoolDownloadAllWordOpen()"
                  style="color: #1bb24b; border-color: #1bb24b"
                  >导WORD</el-button
                >

                <el-button
                  @click="onDialogBoolMultipleStatusOpen()"
                  style="color: #1bb24b; border-color: #1bb24b"
                  >批量改状态</el-button
                >
              </div>

              <div
                style="
                  margin-top: 5px;
                  color: #1bb24b;
                  margin-right: 20px;
                  margin-top: 30px;
                "
              >
                <div style="display: inline-block">
                  订单数量：{{ tableDataTotal }}
                </div>
                <div style="display: inline-block; margin-left: 20px">
                  营业额：{{ tableTotalPrice }}
                </div>
              </div>
            </div>
          </div>

          <div style="margin-top: 20px">
            <el-table
              :data="tableDataList"
              :height="windowHeight - 370"
              @selection-change="onOrderSelection"
              style="width: 100%"
              stripe
            >
              <el-table-column type="selection" width="55"></el-table-column>

              <el-table-column
                prop="orderId"
                label="订单号"
                sortable
                width="80"
              ></el-table-column>
              <el-table-column
                prop="wechat"
                label="微信号"
                width="80"
              ></el-table-column>
              <el-table-column
                prop="name"
                label="姓名"
                width="80"
              ></el-table-column>
              <el-table-column
                prop="phone"
                label="电话"
                width="80"
              ></el-table-column>
              <el-table-column
                prop="userComment"
                label="客户备注"
                width="80"
              ></el-table-column>
              <el-table-column
                prop="address"
                label="地址"
                width="150"
              ></el-table-column>
              <!-- <el-table-column
                prop="paymentWay"
                label="支付方式"
                width="80"
              ></el-table-column> -->

              <el-table-column label="支付方式" width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.paymentWay == '澳元转账'">RoyalPay</div>
                  <div v-else-if="scope.row.paymentWay == 'RMB支付'">银行卡支付</div>
                  <div v-else-if="scope.row.paymentWay == 'RoyalPay'">Superpay</div>
                  <div v-else>{{scope.row.paymentWay}}</div>
                </template>
              </el-table-column>

              <el-table-column
                prop="price"
                label="总价"
                width="80"
              ></el-table-column>

              <el-table-column label="尾款" width="80">
                <template slot-scope="scope">
                  <div>{{ scope.row.restPay }}</div>
                </template>
              </el-table-column>

              <el-table-column
                prop="comment"
                label="后台备注"
                width="80"
              ></el-table-column>
              <el-table-column
                prop="status"
                label="订单状态"
                width="80"
              ></el-table-column>
              <el-table-column
                prop="subName"
                sortable
                label="Sub"
                width="80"
              ></el-table-column>
              <el-table-column
                prop="area"
                sortable
                label="所在大区"
                width="80"
              ></el-table-column>
              <el-table-column
                prop="deliveryDate"
                label="送货时间"
                width="80"
              ></el-table-column>
              <el-table-column
                prop="createTime"
                label="下单时间"
                width="80"
              ></el-table-column>
              <el-table-column
                prop="carName"
                label="货车"
                width="80"
              ></el-table-column>
              <el-table-column
                prop="driverName"
                label="司机"
                width="80"
              ></el-table-column>
              <el-table-column
                prop="carComment"
                label="货车备注"
                width="80"
              ></el-table-column>
              <el-table-column
                prop="paymentId"
                label="支付单号"
                sortable
                width="80"
              ></el-table-column>

              <el-table-column fixed="right" label="操作" width="400">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'car')"
                    >修改货车</el-button
                  >

                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'detail')"
                    >查看订单详情</el-button
                  >

                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'payment')"
                    >查看支付凭证</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'edit')"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'word')"
                    >生成WORD</el-button
                  >

                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'delete')"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 20px; display: inline-block">
            <el-pagination
              background
              :page-size="20"
              :current-page.sync="currentPage"
              layout="prev, pager, next"
              :total="tableDataTotal"
              @current-change="onFetchTableData"
            ></el-pagination>
          </div>
        </div>
      </div>

      <el-dialog
        title="订单操作"
        :visible.sync="boolAddNew"
        width="70%"
        style="text-align: left"
        :before-close="onDialogBoolAddNewClose"
        :close-on-click-modal="false"
      >
        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            配送时间
          </div>
          <el-date-picker
            v-model="form.deliveryDate"
            value-format="yyyy-MM-dd"
            type="datetime"
            placeholder="选择日期"
          ></el-date-picker>
        </div>
        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            姓名
          </div>
          <el-input
            style="display: inline-block; width: 70%"
            v-model="form.name"
            placeholder="请输入姓名"
          ></el-input>
        </div>

        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            电话
          </div>
          <el-input
            style="display: inline-block; width: 70%"
            v-model="form.phone"
            placeholder="请输入电话"
          ></el-input>
        </div>

        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            微信
          </div>
          <el-input
            style="display: inline-block; width: 70%"
            v-model="form.wechat"
            placeholder="请输入微信"
          ></el-input>
        </div>

        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            地址
          </div>
          <el-input
            style="display: inline-block; width: 70%"
            v-model="form.address"
            placeholder="请输入地址"
          ></el-input>
        </div>

        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            sub名称
          </div>
          <el-input
            style="display: inline-block; width: 70%"
            v-model="form.subName"
            placeholder="请输入sub名称"
          ></el-input>
        </div>

        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            所在区
          </div>
          <el-select
            style="display: inline-block; width: 70%"
            v-model="form.area"
          >
            <el-option
              v-for="item in areaList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            总价格
          </div>
          <el-input
            type="number"
            :min="0"
            style="display: inline-block; width: 70%"
            v-model="form.price"
            placeholder="请输入价格"
          ></el-input>
        </div>
        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            运费
          </div>
          <div style="display: inline-block; text-align: left; width: 70%">
            {{ form.areaInfo.price }}
          </div>
        </div>
        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            商品价格
          </div>
          <div style="display: inline-block; text-align: left; width: 70%">
            {{ (form.price - form.areaInfo.price).toFixed(2) }}
          </div>
        </div>

        <div style="margin-top: 20px">
          <div
            style="
              display: inline-block;
              text-align: left;
              width: 10%;
              vertical-align: top;
            "
          >
            订单详情
          </div>

          <div style="display: inline-block; width: 70%">
            <div style="margin-bottom: 20px">
              <el-button
                @click="onDialogBoolAddNewProductOpen()"
                style="
                  display: inline-block;
                  background-color: #1bb24b;
                  vertical-align: middle;
                "
                type="success"
                >增加商品</el-button
              >
            </div>
            <el-table
              border
              :data="form.orderDetail"
              :height="windowHeight - 450"
              style="width: 100%"
              stripe
            >
              <el-table-column
                prop="id"
                label="商品ID"
                sortable
                width="150"
              ></el-table-column>
              <el-table-column prop="title" label="商品名称"></el-table-column>
              <el-table-column prop="price" label="商品价格"></el-table-column>

              <el-table-column label="图片">
                <template slot-scope="scope">
                  <div>
                    <img
                      style="width: 80px; height: 80px"
                      :src="scope.row.imgUrls[0]"
                    />
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="buyNum" label="购买数量"></el-table-column>

              <el-table-column fixed="right" label="操作" width="250">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogProductWithData(scope, 'edit')"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogProductWithData(scope, 'delete')"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div style="margin-top: 20px">
          <div
            style="
              display: inline-block;
              text-align: left;
              width: 10%;
              vertical-align: top;
            "
          >
            司机图片
          </div>
          <div style="display: inline-block; width: 70%">
            <el-upload
              accept=".jpg, .jpeg, .png"
              class="avatar-uploader"
              :show-file-list="false"
              action="https://freshgo.top/api/public/api/v1/uploadFileQiniu"
              :on-success="onOrderImgUpload"
              :on-remove="onOrderImgRemove"
            >
              <img
                v-if="form.deliveryImg"
                :src="form.deliveryImg"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>

        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            订单状态
          </div>
          <el-select
            style="display: inline-block; width: 70%"
            v-model="form.status"
          >
            <el-option
              v-for="item in statusListTwo"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            支付方式
          </div>
          <el-select
            style="display: inline-block; width: 70%"
            v-model="form.paymentWay"
          >
            <el-option
              v-for="item in paymentWayList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>

        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            客户备注
          </div>
          <el-input
            style="display: inline-block; width: 70%"
            v-model="form.userComment"
            disabled
            placeholder="请输入备注"
          ></el-input>
        </div>

        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            备注
          </div>
          <el-input
            style="display: inline-block; width: 70%"
            v-model="form.comment"
            placeholder="请输入备注"
          ></el-input>
        </div>

        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="onEditConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolAddNewClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="产品操作"
        :close-on-click-modal="false"
        :visible.sync="boolAddNewProduct"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolAddNewProductClose"
      >
        <div v-if="!boolProductEdit" style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            产品名称
          </div>
          <el-select
            :disabled="fullscreenLoading"
            style="display: inline-block; width: 70%"
            v-model="formProduct.id"
            @change="onFormProductChange"
            filterable
          >
            <el-option
              v-for="item in productList"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>

        <div v-if="boolProductEdit" style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            产品名称
          </div>
          <el-input
            disabled
            style="display: inline-block; width: 70%"
            v-model="formProduct.title"
            placeholder="请输入产品名称"
          ></el-input>
        </div>

        <div style="margin-top: 20px">
          <div
            style="
              display: inline-block;
              text-align: left;
              width: 10%;
              vertical-align: top;
            "
          >
            产品图片
          </div>
          <div style="display: inline-block; text-align: left; width: 70%">
            <img
              style="width: 80px; height: 80px"
              :src="formProduct.imgUrls[0]"
            />
          </div>
        </div>

        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            购买数量
          </div>
          <el-input
            type="number"
            :min="0"
            style="display: inline-block; width: 70%"
            v-model="formProduct.buyNum"
            placeholder="请输入购买数量"
          ></el-input>
        </div>

        <div style="text-align: right; margin-top: 20px">
          <el-button
            v-if="!boolProductEdit"
            @click="onProductAddNewConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            v-if="boolProductEdit"
            @click="onProductEditConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolAddNewProductClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="导出电话"
        :visible.sync="boolMsgPhone"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolMsgPhoneClose"
      >
        <div style="margin-top: 20px">
          <el-input
            type="textarea"
            style="display: inline-block; width: 100%"
            v-model="msgPhone"
          ></el-input>
        </div>

        <div style="text-align: right; margin-top: 20px">
          <el-button
            v-clipboard:copy="msgPhone"
            v-clipboard:success="onCopyMsgPhone"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >复制</el-button
          >
          <el-button
            @click="onDialogBoolMsgPhoneClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="导出地址、单号、电话"
        :visible.sync="boolAddress"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolAddressClose"
      >
        <div style="text-align: right; margin-top: 20px">
          <download-excel
            :name="excelName"
            style="display: inline-block"
            :data="excelData"
          >
            <el-button
              style="
                display: inline-block;
                margin-right: 20px;
                background-color: #1bb24b;
                width: 125px;
              "
              type="success"
              >下载</el-button
            >
          </download-excel>

          <el-button
            @click="onDialogBoolAddressClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="删除订单"
        :visible.sync="boolDelete"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolDeleteClose"
      >
        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="onDeleteConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolDeleteClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="订单详情"
        :visible.sync="boolDetail"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolDetailClose"
      >
        <div>
          <div style="width: 18%; display: inline-block">下单时间</div>
          <div style="width: 80%; display: inline-block">
            {{ currentData.createTime }}
          </div>
        </div>

        <div style="margin-top: 5px">
          <div style="width: 18%; display: inline-block">配送时间</div>
          <div style="width: 80%; display: inline-block">
            {{ currentData.deliveryDate }}
          </div>
        </div>

        <div style="margin-top: 5px">
          <div style="width: 18%; display: inline-block">客户微信号</div>
          <div style="width: 80%; display: inline-block">
            {{ currentData.wechat }}
          </div>
        </div>

        <div style="margin-top: 5px">
          <div style="width: 18%; display: inline-block">客户姓名</div>
          <div style="width: 80%; display: inline-block">
            {{ currentData.name }}
          </div>
        </div>

        <div style="margin-top: 5px">
          <div style="width: 18%; display: inline-block">电话</div>
          <div style="width: 80%; display: inline-block">
            {{ currentData.phone }}
          </div>
        </div>
        <div style="margin-top: 5px">
          <div style="width: 18%; display: inline-block">地址</div>
          <div style="width: 80%; display: inline-block">
            {{ currentData.address }}
          </div>
        </div>

        <div style="margin-top: 5px">
          <div style="width: 18%; display: inline-block">客户备注</div>
          <div style="width: 80%; display: inline-block">
            {{ currentData.userComment }}
          </div>
        </div>

        <div style="margin-top: 5px">
          <div style="width: 18%; display: inline-block">总金额(包括运费)</div>
          <div style="width: 80%; display: inline-block">
            {{ currentData.price }}
          </div>
        </div>

        <div style="margin-top: 20px">
          <div style="display: inline-block; width: 100%">
            <el-table
              border
              :data="form.orderDetail"
              :height="windowHeight - 450"
              style="width: 100%"
              stripe
            >
              <el-table-column
                prop="id"
                label="商品ID"
                sortable
                width="150"
              ></el-table-column>
              <el-table-column prop="title" label="商品名称"></el-table-column>

              <el-table-column label="图片">
                <template slot-scope="scope">
                  <div>
                    <img
                      style="width: 80px; height: 80px"
                      :src="scope.row.imgUrls[0]"
                    />
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="price" label="商品价格"></el-table-column>
              <el-table-column prop="buyNum" label="购买数量"></el-table-column>
            </el-table>
          </div>
        </div>

        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="onDialogBoolDetailClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >关闭</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="支付凭证"
        :visible.sync="boolPayment"
        width="70%"
        style="text-align: left"
        :before-close="onDialogBoolPaymentClose"
      >
        <el-upload
          accept=".jpg, .jpeg, .png"
          action="https://freshgo.top/api/public/api/v1/uploadFileQiniu"
          list-type="picture-card"
          :on-success="onPaymentImgUpload"
          :on-remove="onPaymentImgRemove"
          :file-list="paymentImgList"
          multiple
        >
          <i class="el-icon-plus"></i>

          <!-- <img v-if="paymentImg" :src="paymentImg" style="width:100%;" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
        </el-upload>
        <img
          style="width: 400px; height: 100%; display: inline-block"
          v-for="(item, index) in paymentImgList"
          :key="index"
          :src="item.url"
        />

        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="onPaymentImgConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolPaymentClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >关闭</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="修改订单下货车信息"
        :visible.sync="boolCar"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolCarClose"
      >
        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            货车
          </div>
          <el-select
            @change="onCarChange"
            style="display: inline-block; width: 70%"
            v-model="formCar.belongCarId"
          >
            <el-option
              v-for="item in carList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>

        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            司机
          </div>
          <el-select
            disabled
            style="display: inline-block; width: 70%"
            v-model="formCar.belongDriverId"
          >
            <el-option
              v-for="item in driverList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>

        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            编号
          </div>
          <el-input
            type="number"
            style="display: inline-block; width: 70%"
            v-model="formCar.carComment"
            placeholder="请输入编号"
          ></el-input>
        </div>

        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="onConfirmCar()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolCarClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="生成Word"
        :visible.sync="boolWord"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolWordClose"
      >
        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="generate"
            style="
              display: inline-block;
              margin-right: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >下载</el-button
          >

          <el-button
            @click="onDialogBoolWordClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >关闭</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="生成全部订单的Word"
        :visible.sync="boolDownloadAllWord"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolWordClose"
      >
        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="generate"
            style="
              display: inline-block;
              margin-right: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >下载</el-button
          >

          <el-button
            @click="onDialogBoolWordClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >关闭</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="批量修改订单状态"
        :visible.sync="boolMultipleStatus"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolMultipleStatusClose"
      >
        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            订单状态
          </div>
          <el-select
            style="display: inline-block; width: 70%"
            v-model="selectedStatus"
          >
            <el-option
              v-for="item in statusListTwo"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="onMultipleStatusChangeConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolMultipleStatusClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import "docxtemplater/build/docxtemplater.js";
import "pizzip/dist/pizzip.js";
import "pizzip/dist/pizzip-utils.js";
import "file-saver";

export default {
  name: "List",
  data() {
    return {
      fullscreenLoading: false,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,

      boolWord: false,
      boolDownloadAllWord: false,
      wordData: [],

      searchKeyword: "",
      searchDate: [],
      searchDeliveryDate: [
        (
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate()
        ).toString(),
        (
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate()
        ).toString(),
      ],
      searchArea: "",
      searchStatus: ["待配送"],
      searchPaymentWay: "",
      searchCar: "",

      currentData: {},
      currentPage: 1,

      tableDataList: [],
      tableDataTotal: 0,
      tableTotalPrice: 0,

      boolAddNew: false,
      boolEdit: false,
      boolDelete: false,
      boolPayment: false,
      boolCar: false,
      boolMsgPhone: false,
      boolAddress: false,

      excelData: [],
      excelName: "",
      msgPhone: "",

      form: {
        name: "",
        phone: "",
        wechat: "",
        address: "",
        subName: "",
        area: "",
        price: "",
        orderDetail: [],
        deliveryImg: "",
        comment: "",
        userComment: "",
        status: "",
        paymentWay: "",
        deliveryDate: "",
        areaInfo: {},
      },

      areaList: [],
      productList: [],
      statusList: ["不限", "待付款", "待配送", "已完成", "已退款", "已取消"],
      statusListTwo: ["待付款", "待配送", "已完成", "已退款", "已取消"],

      currentProductData: {},
      currentProductIndex: 0,

      boolAddNewProduct: false,
      boolProductEdit: false,

      formProduct: {
        id: "",
        title: "",
        imgUrls: [],
        buyNum: "",
        price: "",
      },

      boolDetail: false,

      paymentWaySearchList: [
        {
          value: "不限",
          text: "不限",
        },
        {
          value: "RoyalPay",
          text: "RoyalPay",
        },
        {
          value: "澳元转账",
          text: "Superpay",
        },
        {
          value: "RMB支付",
          text: "银行卡支付",
        },
        {
          value: "货到付款",
          text: "货到付款",
        },
      ],
      // paymentWaySearchList: [
      //     {
      //     label: "不限",
      //     value: "不限",
      //   },
      //   {
      //     label: "微信支付",
      //     value: "RoyalPay",
      //   },
      //   {
      //     label: "澳元转账",
      //     value: "澳元转账",
      //   },
      //   {
      //     label: "RMB支付",
      //     value: "RMB支付",
      //   },
      //   {
      //     label: "货到付款",
      //     value: "货到付款",
      //   },
      // ],

      carList: [],
      carSearchList: [],
      driverList: [],

      formCar: {
        belongCarId: "",
        belongDriverId: "",
        carComment: "",
      },

      paymentWayList: [
        {
          value: "RoyalPay",
          text: "RoyalPay",
        },
        {
          value: "澳元转账",
          text: "Superpay",
        },
        {
          value: "RMB支付",
          text: "银行卡支付",
        },
        {
          value: "货到付款",
          text: "货到付款",
        },
      ],

      paymentImgList: [],

      boolMultipleStatus: false,
      selectedStatus: "",
      tableSelection: [],
    };
  },
  mounted() {},
  created() {
    this.onCheckloginRole();
    this.onFetchTableData();
    this.onFetchAreaData();
    this.onFetchCar();
    this.onFetchTableDataForWord();
    this.onFetchDriver();
    // this.onFetchProductData();
  },
  methods: {
    // check if  login
    onCheckloginRole() {
      // var temp = localStorage.getItem("auth");
      // if (temp == undefined || temp != "b60afdc1f3657130c165d32743603a59") {
      //   this.$router.push("/login");
      // }
      var temp = localStorage.getItem("auth");
      this.axios
        .post(this.$urlGlobal + "adminCheck", {
          auth: temp,
        })
        .then((res) => {
          if (res.data.code == -1) {
            this.$router.push("/login");
            localStorage.removeItem("auth");
            window.location.reload();
          }
        });
    },
    onFetchProductData() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminFetchAllProduct", {})
        .then((res) => {
          this.productList = res.data.data;
          this.fullscreenLoading = false;
        });
    },
    // init data
    onFetchAreaData() {
      this.fullscreenLoading = true;
      this.axios.post(this.$urlGlobal + "adminFetchArea", {}).then((res) => {
        this.areaList.push("不限");
        for (var i = 0; i < res.data.data.length; i++) {
          this.areaList.push(res.data.data[i].name);
        }
        this.fullscreenLoading = false;
      });
    },

    // fetch car
    onFetchCar() {
      this.fullscreenLoading = true;
      this.axios.post(this.$urlGlobal + "adminFetchCar", {}).then((res) => {
        this.carList = res.data.data;
        this.carSearchList = res.data.data;
        this.carSearchList.push({ name: "不限货车", id: "" });
        this.fullscreenLoading = false;
      });
    },

    // fetch driver
    onFetchDriver() {
      this.fullscreenLoading = true;
      this.axios.post(this.$urlGlobal + "adminFetchDriver", {}).then((res) => {
        this.driverList = res.data.data;
        console.log(this.driverList);
        this.fullscreenLoading = false;
      });
    },

    // search  table by name
    onSearchTableData() {
      console.log(this.searchDeliveryDate);
      // init the page and fetch data
      this.currentPage = 1;
      this.onFetchTableData();
    },
    // fetch table data also with condition
    onFetchTableData() {
      var startTime = "";
      var endTime = "";
      if (this.searchDate != null && this.searchDate.length > 0) {
        startTime = this.searchDate[0];
        endTime = this.searchDate[1];
      }

      var deliveryStart = "";
      var deliveryEnd = "";
      if (
        this.searchDeliveryDate != null &&
        this.searchDeliveryDate.length > 0
      ) {
        deliveryStart = this.searchDeliveryDate[0];
        deliveryEnd = this.searchDeliveryDate[1];
      }
      var searchStatus = this.searchStatus;
      if (this.searchStatus.includes("不限") || this.searchStatus.length == 0) {
        searchStatus = "";
      }

      var searchPaymentWay = this.searchPaymentWay;
      if (this.searchPaymentWay == "不限") {
        searchPaymentWay = "";
      }

      var searchArea = this.searchArea;
      if (this.searchArea == "不限") {
        searchArea = "";
      }

      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminFetchOrder", {
          keyword: this.searchKeyword,
          startTime: startTime,
          endTime: endTime,
          deliveryStart: deliveryStart,
          deliveryEnd: deliveryEnd,
          area: searchArea,
          page: this.currentPage,
          perPage: true,
          status: searchStatus,
          paymentWay: searchPaymentWay,
          car: this.searchCar,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          for (var i = 0; i < res.data.data.data.length; i++) {
            if (
              res.data.data.data[i].price > 20 &&
              res.data.data.data[i].paymentWay == "货到付款"
            ) {
              res.data.data.data[i].restPay = (
                res.data.data.data[i].price - 20
              ).toFixed(2);
            } else {
              res.data.data.data[i].restPay = 0;
            }
            for (var n = 0; n < res.data.data.data[i].orderDetail.length; n++) {
              res.data.data.data[i].orderDetail[n].totalPrice = (
                res.data.data.data[i].orderDetail[n].price *
                res.data.data.data[i].orderDetail[n].buyNum
              ).toFixed(2);
            }
          }
          this.tableDataList = res.data.data.data;
          this.tableDataTotal = res.data.data.total;

          this.tableTotalPrice = res.data.totalPrice.toFixed(2);
          this.onFetchTableDataForWord();
        });
    },

    onFetchTableDataForWord() {
      this.fullscreenLoading = true;
      // console.log(this.searchStatus);
      var startTime = "";
      var endTime = "";
      if (this.searchDate != null && this.searchDate.length > 0) {
        startTime = this.searchDate[0];
        endTime = this.searchDate[1];
      }

      var deliveryStart = "";
      var deliveryEnd = "";
      if (
        this.searchDeliveryDate != null &&
        this.searchDeliveryDate.length > 0
      ) {
        deliveryStart = this.searchDeliveryDate[0];
        deliveryEnd = this.searchDeliveryDate[1];
      }

      var searchStatus = this.searchStatus;
      if (this.searchStatus.includes("不限") || this.searchStatus.length == 0) {
        searchStatus = "";
      }

      var searchPaymentWay = this.searchPaymentWay;
      if (this.searchPaymentWay == "不限") {
        searchPaymentWay = "";
      }

      var searchArea = this.searchArea;
      if (this.searchArea == "不限") {
        searchArea = "";
      }

      this.axios
        .post(this.$urlGlobal + "adminFetchOrder", {
          keyword: this.searchKeyword,
          startTime: startTime,
          endTime: endTime,
          deliveryStart: deliveryStart,
          deliveryEnd: deliveryEnd,
          page: this.currentPage,
          perPage: false,
          area: searchArea,
          status: searchStatus,
          paymentWay: searchPaymentWay,
          car: this.searchCar,
        })
        .then((res) => {
          this.fullscreenLoading = false;

          for (var i = 0; i < res.data.data.length; i++) {
            if (
              res.data.data[i].price > 30 &&
              res.data.data[i].paymentWay == "货到付款"
            ) {
              res.data.data[i].restPay = res.data.data[i].price - 30;
            } else {
              res.data.data[i].restPay = 0;
            }
            for (var n = 0; n < res.data.data[i].orderDetail.length; n++) {
              res.data.data[i].orderDetail[n].totalPrice = (
                res.data.data[i].orderDetail[n].price *
                res.data.data[i].orderDetail[n].buyNum
              ).toFixed(2);

              if (res.data.data[i].paymentWay == "RoyalPay") {
                res.data.data[i].paymentWay = "微信支付";
              }
            }
          }
          this.wordData = res.data.data;

          // 导出电话部分
          var temp = "";
          for (var i = 0; i < this.wordData.length; i++) {
            var phoneTemp = this.wordData[i].phone;
            phoneTemp = phoneTemp.replace(/\s*/g, "");
            if (phoneTemp.substring(0, 1) != 0) {
              phoneTemp = "0" + phoneTemp;
            }
            temp += phoneTemp + ",";
          }
          this.msgPhone = temp;

          // 同时还计算出营业额度
          var total = 0;
          for (var i = 0; i < res.data.data.length; i++) {
            total += parseFloat(res.data.data[i].price);
          }
          this.tableTotalPrice = total.toFixed(2);
          // console.log(res.data.data);

          this.excelData = [];
          var temp = [];
          var startTime = "";
          var endTime = "";
          if (
            this.searchDeliveryDate != null &&
            this.searchDeliveryDate.length > 0
          ) {
            startTime = this.searchDeliveryDate[0];
            endTime = this.searchDeliveryDate[1];
          }
          for (var i = 0; i < this.wordData.length; i++) {
            var phoneTemp = this.wordData[i].phone;
            phoneTemp = phoneTemp.replace(/\s*/g, "");
            if (phoneTemp.substring(0, 1) != 0) {
              phoneTemp = "'0" + phoneTemp;
            } else {
              phoneTemp = "'" + phoneTemp;
            }

            console.log("------------------------" + phoneTemp);
            temp.push({
              单号: this.wordData[i].orderId,
              地址: this.wordData[i].address,
              电话: phoneTemp,
            });
          }
          var d = new Date();
          var n = d.getDate();
          var y = d.getFullYear();
          var m = d.getMonth() + 1;
          this.excelName = "freshgo 货车单 " + startTime + "至" + endTime;
          // this.excelName = this.currentData.name;
          this.excelData = temp;
        });
    },

    // add new  operation
    onDialogBoolAddNewOpen() {
      this.boolAddNew = true;
    },
    onDialogBoolAddNewClose() {
      this.boolAddNew = false;
      // also close edit because they use same form
      this.boolEdit = false;
      this.form = {
        name: "",
        phone: "",
        wechat: "",
        address: "",
        subName: "",
        price: "",
        area: "",
        orderDetail: [],
        deliveryImg: "",
        comment: "",
        status: "",
        paymentWay: "",
        deliveryDate: "",
        areaInfo: {},
      };
    },

    // edit  operation
    onDialogBoolEditOpen() {
      this.boolAddNew = true;
      this.boolEdit = true;
      this.form = {
        name: this.currentData.name,
        phone: this.currentData.phone,
        wechat: this.currentData.wechat,
        address: this.currentData.address,
        subName: this.currentData.subName,
        price: this.currentData.price,
        area: this.currentData.area,
        orderDetail: this.currentData.orderDetail,
        deliveryImg: this.currentData.deliveryImg,
        comment: this.currentData.comment,
        userComment: this.currentData.userComment,
        status: this.currentData.status,
        paymentWay: this.currentData.paymentWay,
        deliveryDate: this.currentData.deliveryDate,
        areaInfo: this.currentData.areaInfo,
      };
    },
    onEditConfirm() {
      if (
        this.form.name == "" ||
        this.form.subName == "" ||
        this.form.area == "" ||
        this.form.phone == "" ||
        this.form.address == "" ||
        this.form.deliveryDate == ""
      ) {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminEditOrder", {
          id: this.currentData.id,
          name: this.form.name,
          phone: this.form.phone,
          wechat: this.form.wechat,
          address: this.form.address,
          subName: this.form.subName,
          price: this.form.price,
          area: this.form.area,
          orderDetail: this.form.orderDetail,
          deliveryImg: this.form.deliveryImg,
          comment: this.form.comment,
          paymentWay: this.form.paymentWay,
          deliveryDate: this.form.deliveryDate,
          status: this.form.status,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == 1) {
            this.$message({
              message: "修改失败",
              type: "warning",
            });
            return;
          } else {
            this.$message({
              message: "修改成功",
              type: "success",
            });
          }
          this.onDialogBoolAddNewClose();
          this.onFetchTableData();
        });
    },

    // delete  operation
    onDialogBoolDeleteOpen() {
      this.boolDelete = true;
    },
    onDialogBoolDeleteClose() {
      this.boolDelete = false;
    },
    onDeleteConfirm() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminDeleteOrder", {
          id: this.currentData.id,
        })
        .then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.onDialogBoolDeleteClose();
          this.onFetchTableData();
          this.fullscreenLoading = false;
        });
    },

    // table operation
    onDialogWithData(scope, e) {
      this.currentData = scope.row;
      switch (e) {
        case "car":
          this.onDialogBoolCarOpen();
          break;
        case "detail":
          this.onDialogBoolDetailOpen();
          break;
        case "word":
          this.onDialogBoolWordOpen();
          break;
        case "edit":
          this.onDialogBoolEditOpen();
          break;
        case "delete":
          this.onDialogBoolDeleteOpen();
          break;
        case "payment":
          this.onDialogBoolPaymentOpen();
          break;
      }
    },

    onDialogBoolCarOpen() {
      this.boolCar = true;
      this.formCar = {
        belongCarId: this.currentData.belongCarId,
        belongDriverId: this.currentData.belongDriverId,
        carComment: this.currentData.carComment,
      };
    },
    onCarChange(e) {
      for (var i = 0; i < this.carList.length; i++) {
        if (this.carList[i].id == e) {
          this.formCar.belongDriverId = this.carList[i].belongDriverId;
        }
      }
    },

    onDialogBoolCarClose() {
      this.boolCar = false;
    },

    onConfirmCar() {
      if (this.formCar.belongCarId == "" || this.formCar.belongDriverId == "") {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }
      this.fullscreenLoading = true;
      var temp = [];
      this.axios
        .post(this.$urlGlobal + "adminUpdateCarToOrder", {
          id: this.currentData.id,
          belongCarId: this.formCar.belongCarId,
          belongDriverId: this.formCar.belongDriverId,
          carComment: this.formCar.carComment,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.onDialogBoolCarClose();
          this.onFetchTableData();
        });
    },

    onDialogBoolPaymentOpen() {
      this.boolPayment = true;
      var temp = [];
      if (this.currentData.paymentImg != null) {
        for (var i = 0; i < this.currentData.paymentImg.length; i++) {
          temp.push({ name: i, url: this.currentData.paymentImg[i] });
        }
      }

      this.paymentImgList = temp;
    },

    onDialogBoolPaymentClose() {
      this.boolPayment = false;
    },

    onDialogBoolWordOpen() {
      this.wordData = [];
      this.boolWord = true;
      var temp = [];
      if (
        this.currentData.price > 30 &&
        this.currentData.paymentWay == "货到付款"
      ) {
        this.currentData.restPay = this.currentData.price - 30;
      } else {
        this.currentData.restPay = 0;
      }

      for (var i = 0; i < this.currentData.orderDetail.length; i++) {
        this.currentData.orderDetail[i].totalPrice = (
          this.currentData.orderDetail[i].price *
          this.currentData.orderDetail[i].buyNum
        ).toFixed(2);
      }

      if (this.currentData.paymentWay == "RoyalPay") {
        this.currentData.paymentWay = "微信支付";
      }

      temp.push(this.currentData);
      // console.log(temp);
      this.wordData = temp;
    },
    // word operation
    onDialogBoolWordClose() {
      this.boolWord = false;
      this.wordData = [];
      this.boolDownloadAllWord = false;
    },
    onDialogBoolDownloadAllWordOpen() {
      this.wordData = [];
      this.boolDownloadAllWord = true;
      this.onFetchTableDataForWord();
    },

    // detial operation
    onDialogBoolDetailOpen() {
      this.boolDetail = true;
      console.log(this.currentData.orderDetail);
      if (this.currentData.orderDetail != null) {
        this.form.orderDetail = this.currentData.orderDetail;
      }
    },
    onDialogBoolDetailClose() {
      this.boolDetail = false;
      this.form.orderDetail = [];
    },

    // inside order product operation
    onDialogProductWithData(scope, e) {
      this.currentProductData = scope.row;
      this.currentProductIndex = scope.$index;
      console.log();
      switch (e) {
        case "edit":
          this.onDialogBoolProductEditOpen();
          break;
        case "delete":
          this.onDialogBoolProductDeleteConfirm();
          break;
      }
    },
    // upload description image
    onOrderImgUpload(file) {
      this.form.deliveryImg = file.data;
    },
    onOrderImgRemove(file, fileList) {
      this.form.deliveryImg = "";
    },

    // add product
    onDialogBoolAddNewProductOpen() {
      this.boolAddNewProduct = true;
      this.onFetchProductData();
    },
    onDialogBoolAddNewProductClose() {
      this.boolAddNewProduct = false;
      this.boolProductEdit = false;
      this.formProduct = {
        id: "",
        title: "",
        belongShopId: "",
        imgUrls: [],
        price: "",
        buyNum: "",
      };
    },
    onProductAddNewConfirm() {
      console.log(this.formProduct);
      if (
        this.formProduct.id == "" ||
        this.formProduct.title == "" ||
        this.formProduct.imgUrls == "" ||
        this.formProduct.price == "" ||
        this.formProduct.buyNum == "" ||
        this.formProduct.buyNum == undefined ||
        this.formProduct.buyNum == 0
      ) {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }
      this.form.orderDetail.push(this.formProduct);
      // 计算总价
      this.form.price = 0;
      for (var i = 0; i < this.form.orderDetail.length; i++) {
        this.form.price +=
          this.form.orderDetail[i].price * this.form.orderDetail[i].buyNum;
      }
      this.onDialogBoolAddNewProductClose();
    },

    // edit product
    onDialogBoolProductEditOpen() {
      this.boolAddNewProduct = true;
      this.boolProductEdit = true;
      console.log();
      this.formProduct = this.currentProductData;
    },
    onFormProductChange(val) {
      for (var i = 0; i < this.productList.length; i++) {
        if (this.productList[i].id == val) {
          this.formProduct.id = val;
          this.formProduct = this.productList[i];
          break;
        }
      }
    },
    onProductEditConfirm() {
      if (
        this.formProduct.id == "" ||
        this.formProduct.title == "" ||
        this.formProduct.imgUrls == "" ||
        this.formProduct.buyNum == "" ||
        this.formProduct.buyNum == undefined ||
        this.formProduct.buyNum == 0
      ) {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }
      this.form.orderDetail[
        this.currentProductIndex
      ].buyNum = this.formProduct.buyNum;

      this.form.price = 0;
      for (var i = 0; i < this.form.orderDetail.length; i++) {
        this.form.price +=
          this.form.orderDetail[i].price * this.form.orderDetail[i].buyNum;
      }
      this.onDialogBoolAddNewProductClose();
    },

    // delete product
    onDialogBoolProductDeleteConfirm() {
      var temp = [];
      for (var i = 0; i < this.form.orderDetail.length; i++) {
        if (i == this.currentProductIndex) {
          continue;
        }
        temp.push(this.form.orderDetail[i]);
      }
      this.form.orderDetail = temp;
      this.form.price = 0;
      for (var i = 0; i < this.form.orderDetail.length; i++) {
        this.form.price +=
          this.form.orderDetail[i].price * this.form.orderDetail[i].buyNum;
      }
    },

    // multiple status change
    onOrderSelection(val) {
      console.log(val);
      this.tableSelection = val;
    },
    onDialogBoolMultipleStatusOpen() {
      this.boolMultipleStatus = true;
    },
    onDialogBoolMultipleStatusClose() {
      this.boolMultipleStatus = false;
      this.selectedStatus = "";
    },
    onMultipleStatusChangeConfirm() {
      this.fullscreenLoading = true;
      var temp = [];
      for (var i = 0; i < this.tableSelection.length; i++) {
        temp.push(this.tableSelection[i].id);
      }
      this.axios
        .post(this.$urlGlobal + "adminModifyMultipleOrderStatus", {
          ids: temp,
          status: this.selectedStatus,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.onDialogBoolMultipleStatusClose();
          this.onFetchTableData();
        });
    },

    // payment
    onPaymentImgUpload(res, file, fileList) {
      this.paymentImgList = fileList;
    },

    onPaymentImgRemove(file, fileList) {
      this.paymentImgList = fileList;
    },

    onPaymentImgConfirm() {
      var imgUrl = [];
      for (var i = 0; i < this.paymentImgList.length; i++) {
        if (this.paymentImgList[i].response != undefined) {
          imgUrl.push(this.paymentImgList[i].response.data);
        } else {
          imgUrl.push(this.paymentImgList[i].url);
        }
      }
      this.axios
        .post(this.$urlGlobal + "adminUpdatePaymentImg", {
          id: this.currentData.id,
          paymentImg: imgUrl,
        })
        .then((res) => {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.onFetchTableData();
        });
    },

    // load word file
    // 导出word
    loadFile(url, callback) {
      PizZipUtils.getBinaryContent(url, callback);
    },
    generate() {
      var startTime = "";
      var endTime = "";
      if (this.searchDate != null && this.searchDate.length > 0) {
        startTime = this.searchDate[0];
        endTime = this.searchDate[1];
      }

      var that = this;
      this.loadFile(
        "https://freshgo.top/template/word.docx",
        function (error, content) {
          if (error) {
            throw error;
          }
          var zip = new PizZip(content);
          var doc = new window.docxtemplater().loadZip(zip);

          var tempWord = that.wordData;
          for (var i = 0; i < tempWord.length; i++) {
            var phoneTemp = tempWord[i].phone;
            if (phoneTemp.substring(0, 1) != 0) {
              phoneTemp = "0" + phoneTemp;
            }
            tempWord[i].phone = phoneTemp;
          }

          doc.setData({
            orderList: tempWord,
          });
          try {
            // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
            doc.render();
          } catch (error) {
            var e = {
              message: error.message,
              name: error.name,
              stack: error.stack,
              properties: error.properties,
            };
            console.log(
              JSON.stringify({
                error: e,
              })
            );
            // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
            throw error;
          }
          var out = doc.getZip().generate({
            type: "blob",
            mimeType:
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          }); //Output the document using Data-URI
          // var d = new Date();
          // var n = d.getDate();
          // var y = d.getFullYear();
          // var m = d.getMonth() + 1;
          var startTime = "";
          var endTime = "";
          if (
            that.searchDeliveryDate != null &&
            that.searchDeliveryDate.length > 0
          ) {
            startTime = that.searchDeliveryDate[0];
            endTime = that.searchDeliveryDate[1];
          }
          console.log(startTime);
          if (that.boolDownloadAllWord == true) {
            if (startTime == "" || endTime == "") {
              saveAs(out, "freshgo 总配送单号.docx");
            } else {
              saveAs(
                out,
                "freshgo 总配送单 " + startTime + "至" + endTime + ".docx"
              );
            }
          } else {
            saveAs(
              out,
              "freshgo " +
                that.currentData.name +
                " " +
                that.currentData.deliveryDate.split(" ")[0] +
                ".docx"
            );
          }
        }
      );
    },

    // msg phone
    onDialogBoolMsgPhoneOpen() {
      this.boolMsgPhone = true;
      console.log(this.wordData);
      var temp = "";
      for (var i = 0; i < this.wordData.length; i++) {
        var phoneTemp = this.wordData[i].phone;
        phoneTemp = phoneTemp.replace(/\s*/g, "");
        if (phoneTemp.substring(0, 1) != 0) {
          phoneTemp = "0" + phoneTemp;
        }
        temp += phoneTemp + ",";
      }
      this.msgPhone = temp;
    },
    onDialogBoolMsgPhoneClose() {
      this.boolMsgPhone = false;
    },
    onCopyMsgPhone() {
      // let container = this.$refs.container;
      // this.$copyText("Text to copy", container);
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },

    onDialogBoolAddressOpen() {
      this.boolAddress = true;
    },

    onDialogBoolAddressClose() {
      this.boolAddress = false;
    },
  },
};
</script>

<style>
.el-range-editor .el-range-input {
  vertical-align: top;
}
.el-date-editor .el-range-separator {
  padding: 0 5px;
  line-height: 32px;
  width: 5%;
  color: #303133;
  vertical-align: top;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
